import React from "react";
import { ArrowLeft, ArrowRight, ShieldCheck, Handshake, Eye, LayoutDashboard, Wallet, Cpu, Zap, CircleDollarSign, Unlock, Boxes, Users, GraduationCap } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "../ui/dialog";
import { Button } from "../ui/button";

export const DIFFERENTIAL_ICONS = [ShieldCheck, Handshake, Eye, LayoutDashboard, Wallet, Cpu, Zap, CircleDollarSign, Unlock, Boxes, Users, GraduationCap];

export const DifferentialDialog = ({ t, open, onOpenChange, activeIndex, onSelect, onCloseAutoFocus }) => {
  const reduceMotion = useReducedMotion();
  const item = t.items[activeIndex];
  const Icon = DIFFERENTIAL_ICONS[activeIndex];
  const move = (direction) => onSelect((activeIndex + direction + t.items.length) % t.items.length);
  const handleKeyDown = (event) => {
    if (event.altKey || event.ctrlKey || event.metaKey) return;
    if (event.key === "ArrowLeft" || event.key === "ArrowRight") {
      event.preventDefault();
      move(event.key === "ArrowLeft" ? -1 : 1);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="why-detail-dialog"
        closeLabel={t.detail.close}
        closeTestId="why-detail-close"
        overlayTestId="why-detail-overlay"
        onKeyDown={handleKeyDown}
        onCloseAutoFocus={onCloseAutoFocus}
        data-testid="why-detail-dialog"
      >
        <p className="why-detail-kicker" data-testid="why-detail-kicker">{t.kicker}</p>
        <motion.div
          key={activeIndex}
          className="why-detail-copy"
          initial={reduceMotion ? false : { opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: reduceMotion ? 0 : 0.2 }}
          aria-live="polite"
          aria-atomic="true"
          data-testid="why-detail-content"
        >
          <div className="why-detail-heading">
            <span className="why-detail-icon" aria-hidden="true" data-testid="why-detail-icon"><Icon /></span>
            <DialogTitle className="why-detail-title" data-testid="why-detail-title">{item.title}</DialogTitle>
          </div>
          <div className="why-detail-body" data-testid="why-detail-body">
            <DialogDescription className="why-detail-definition" data-testid="why-detail-definition">{item.definition}</DialogDescription>
          </div>
        </motion.div>
        <div className="why-detail-navigation" data-testid="why-detail-navigation">
          <Button type="button" variant="outline" size="icon" className="why-detail-arrow" aria-label={t.detail.previous} title={t.detail.previous} onClick={() => move(-1)} data-testid="why-detail-previous">
            <ArrowLeft aria-hidden="true" />
          </Button>
          <p className="why-detail-counter" aria-live="polite" aria-atomic="true" data-testid="why-detail-counter">
            <span>{t.detail.label}</span>
            <strong>{String(activeIndex + 1).padStart(2, "0")}</strong>
            <span aria-hidden="true">/</span>
            <span>{String(t.items.length).padStart(2, "0")}</span>
          </p>
          <Button type="button" variant="outline" size="icon" className="why-detail-arrow" aria-label={t.detail.next} title={t.detail.next} onClick={() => move(1)} data-testid="why-detail-next">
            <ArrowRight aria-hidden="true" />
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};